export enum Orientation {
  NotJPEG = -2,
  NotDefined = -1,
  RotateNoneFlipNone = 1,
  RotateNoneFlipX = 2,
  Rotate180FlipNone = 3,
  Rotate180FlipX = 4,
  Rotate90FlipX = 5,
  Rotate90FlipNone = 6,
  Rotate270FlipX = 7,
  Rotate270FlipNone = 8
}

export module ImagePropertiesHelper {
  declare var Promise: any;

  /**
   * Returns the orientation of image based on EXIF tag
   * https://stackoverflow.com/a/32490603
   * Why? TFS 679745 - For camera pictures, there is orientation information in EXIF file.
   * We extract it here and then apply the rotation on rendered image in drawResizedImageOnCanvas method
   * @param image Image file as a blob
   * @param callback callback to call after extracting orientation info
   */
  export function getImageOrientation(fileBlob: any): Promise<Orientation> {
    return new Promise((resolve: any, reject: any) => {

      const reader = new FileReader();
      reader.onloadend = function(e: Event) {

        const view = new DataView(this.result as ArrayBuffer);
        if (view.getUint16(0, false) !== 0xFFD8) return resolve(Orientation.NotJPEG);
        const length = view.byteLength;
        let offset = 2;
        while (offset < length) {
          const marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) return resolve(Orientation.NotDefined);
            const little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            const tags = view.getUint16(offset, little);
            offset += 2;
            for (let i = 0; i < tags; i++)
              if (view.getUint16(offset + (i * 12), little) === 0x0112)
                return resolve(view.getUint16(offset + (i * 12) + 8, little) as Orientation);
          }
          else if ((marker & 0xFF00) !== 0xFF00) break;
          else offset += view.getUint16(offset, false);
        }
        return resolve(Orientation.NotJPEG);
      };

      reader.readAsArrayBuffer(fileBlob);
    });
  }
}
